// all Data Management api routes

export const dataManagementApiRoutes = {
  downloadVendorSkuPoTemplate: '/v1/data-management/download-template',
  validateAndUploadFiles: '/v1/data-management/upload-file',
  getVendorErrorRows: '/v1/data-management/get-vendor-error-rows',
  getSkuErrorRows: '/v1/data-management/get-sku-error-rows',
  getErrorRowsAndMissingFieldCount: '/v1/data-management/missing-fields-rows-count',
  getPoErrorRows: '/v1/data-management/get-po-error-rows',
  deleteErrorRecords: '/v1/data-management/delete-error-records',
  getVendorEnrichedData: '/v1/data-management/get-enriched-vendors',
  getSkuEnrichedData: '/v1/data-management/get-enriched-sku',
  saveVendorEditEnrichData: '/v1/data-management/update-multiple-vendors',
  saveSkuEditEnrichData: '/v1/data-management/update-multiple-sku',
  getSkuData: '/v1/data-management/sku-po-landing-data',
  getVendorData: '/v1/data-management/get-vendor-data',
  getTotalSkuCount: '/v1/data-management/get-total-sku-count',
  getTotalVendorCount: '/v1/data-management/get-total-vendor-count',
  downloadErrorFile: '/v1/data-management/download-error-file',
  triggerEnrichment: '/v1/data-management/trigger-for-enrichment',
  saveResolvedErrorRows: '/v1/data-management/save-error-resolved-rows',
  getAllVendorData: '/v1/data-management/get-vendor-data',
  getEditSkuData: '/v1/data-management/fetch-sku-data-for-edit',
  getEditPoData: '/v1/data-management/fetch-po-data-for-edit',
  abortEnrichment: '/v1/data-management/abort-enrichment-process',
  saveEditedData: '/v1/data-management/save-edited-landing-page-rows',
  deleteVendorsOnEdit: '/v1/data-management/delete-vendor-records',
  deleteSkusOnEdit: '/v1/data-management/delete-sku-records',
  deletePosOnEdit: '/v1/data-management/delete-po-records',
  skipEnrichReview: '/v1/data-management/reset-enriched-count',
  showEnrichmentProgress: '/v1/data-management/get-enrichment-progress',
  getAdlsSasUrl: '/v1/data-management/get-adls-saas-url',
  showFileValidationProgress: '/v1/data-management/get-upload-percentage',
  cancelValidations: '/v1/data-management/cancel-upload',
  getTaxonomyVendorSkuIdOptions: '/v1/data-management/get-options-for-edit',
  getFilters: '/v1/data-management/get-filters',
  getHtCode: '/v1/hts-code/search',
  getEnrichContext: '/v1/data-management/get-enrich-context',
  getTotalPoCount: '/v1/data-management/get-total-po-count',
  getSkuErrorCount: "/v1/data-management/get-sku-error-rows-count",
  getVendorErrorCount: "/v1/data-management/get-vendor-error-rows-count",
  getPoErrorCount: "/v1/data-management/get-po-error-rows-count",
  getVendorEnrichCount: "/v1/data-management/get-enriched-vendors-count",
  getSkuEnrichCount: "/v1/data-management/get-enriched-sku-count",
  getIsSkipEnrich: "/v1/data-management/get-is-enrich-skipped",
  saveIsSkipEnrich: "/v1/data-management/save-is-enrich-skipped",
  getEnrichedConfidenceScore: "/v1/data-management/get-confidence-count",
  skipReviewEnrichedLater: "/v1/data-management/skip-enrichment-review",
  saveEnrichedData: "/v1/data-management/save-enrichment-data"
}
